var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgDebt = function SvgDebt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#1F313A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.375 32.856V26A6.382 6.382 0 0026 19.625 6.382 6.382 0 0019.625 26v6.856a2.23 2.23 0 00-1.547 2.12V38h15.844v-3.023c0-.991-.65-1.832-1.547-2.12zm-11.344-1.653h9.938v1.547H21.03v-1.547zM26 21.031A4.974 4.974 0 0130.969 26v3.797H21.03V26A4.974 4.974 0 0126 21.031zm6.516 15.563H19.484v-1.617c0-.453.368-.82.82-.82h11.391c.453 0 .82.367.82.82v1.617zM25.297 14h1.406v3.377h-1.406V14zM28.724 17.641l1.256-3.133 1.305.523-1.256 3.133-1.305-.523zM31.672 19.273l2.276-2.496 1.04.948-2.276 2.495-1.04-.947zM20.715 15.023l1.305-.523 1.256 3.134-1.305.523-1.256-3.134zM17.018 17.727l1.039-.948 2.276 2.495-1.04.948-2.275-2.495z",
    fill: "#56CCF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.297 22.578h1.406v3.813h-1.406v-3.813zM25.297 27.36h1.406v1.406h-1.406v-1.407z",
    fill: "#56CCF2"
  })));
};

export default SvgDebt;